import footerBrands from 'assets/images/footer_brands.png'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import StringConst from '../../../constants/StringConst'
import './Footer.scss'


class Footer extends Component {

    render() {
        return (
            <div id='footer' className='footer'>
                <Row id='footer-row' className='d-flex align-items-center pt-3 pb-3'>
                    <Col id='footer-brands-logo-column' xs={12} sm={12} lg={12} xl={12} className='brands-logo'>
                        <img id='footer-brands-logo' src={footerBrands} className='brands' />
                        <br />
                        <span id='footer-copyright' className='copyright'>{StringConst.COPYRIGHT}</span>
                        <br />
                        <span id='footer-version' className='version'>{StringConst.APP_VERSION}</span>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Footer